<template>
  <div
    class="app-main-inner tracking-detail-form"
    style="display: flex;flex-direction: column;"
  >
    <div class="app-main-inner-row" style="height: 100%; margin-left: -32px !important;">
      <div style="display: flex;flex-direction: row;">
        <!--明细-->
        <el-card class="box-card" style="width: 450px;">
          <div slot="header">
            <span>{{ title }}</span>
          </div>
          <el-form ref="trackingDetailForm" :disabled="readOnly" style="width:100%; margin-bottom: 20px" label-position="left" label-width="90px">
            <el-form-item :label="$t('Pricing.FeeIndex')">
              <div style="display: flex">
                <el-input
                  v-model="trackingDetailForm.level"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  type="number"
                />
                <el-checkbox v-model="trackingDetailForm.defaultNode" style="margin-left: 5px">{{ $t('Sop.InitialState') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Code')">
              <el-input
                v-model="trackingDetailForm.code"
                :disabled="isPlatformCode && isEdit"
                @blur="() => trackingDetailForm.code = trackingDetailForm.code.trim()"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ChineseName')">
              <el-input
                v-model="trackingDetailForm.codeCname"
                :disabled="isPlatformCode && isEdit"
                @blur="() => trackingDetailForm.codeCname = trackingDetailForm.codeCname.trim()"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EnglishName')">
              <el-input
                v-model="trackingDetailForm.codeEname"
                :disabled="isPlatformCode && isEdit"
                @blur="() => trackingDetailForm.codeEname = trackingDetailForm.codeEname.trim()"
              />
            </el-form-item>
            <el-form-item :label="$t('Sop.StatusType')">
              <el-select v-model="trackingDetailForm.stateType">
                <el-option v-for="item in stateTypes" :key="item.value" :label="isZh ? item.chineseName : item.englishName" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.type" @change="typeChange">{{ $t('Sop.AutomaticTriggering') }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-radio-group v-model="trackingDetailForm.triggerWay" :disabled="!trackingDetailForm.type" @change="triggerWayChange">
                <el-radio :label="TRIGGER_WAY_ENUM.FIELD">{{ $t('SystemMaintenance.TriggerBasedOnFieldValue') }}</el-radio>
                <el-radio :label="TRIGGER_WAY_ENUM.SPECIFIC_BUSINESS_RULE">{{ $t('SystemMaintenance.TriggeredToSpecificBusinessRules') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TriggerType')">
              <!-- 根据字段值触发 -->
              <template v-if="trackingDetailForm.triggerWay === TRIGGER_WAY_ENUM.FIELD">
                <el-input v-if="readOnly || !(trackingDetailForm.type)" :value="fieldEventName" disabled />
                <trigger-dialog
                  v-else
                  :row-data="triggerTypeList"
                  :title="$t('CargoMsg.Cargo_TriggerTypeSelection')"
                  :column-defs="triggerTypeConfigMap.columnDefs"
                  :filter-keys="triggerTypeConfigMap.filterKeys"
                  :value="trackingDetailForm.event"
                  :event-name="fieldEventName"
                  @change="changeFieldTrigger"
                />
              </template>
              <!-- 根据特定业务规则触发 -->
              <template v-else-if="trackingDetailForm.triggerWay === TRIGGER_WAY_ENUM.SPECIFIC_BUSINESS_RULE && !!specificBusinessRules">
                <el-input v-if="readOnly || !trackingDetailForm.type || !specificBusinessRules" :value="specificBusinessRuleEventName" disabled />
                <specific-business-rule-dialog
                  v-else
                  input-width="100%"
                  :lob="currentLob"
                  :apply-sop-state-trigger="true"
                  :specific-business-rule-uuid="trackingDetailForm.event"
                  :specific-business-rules="specificBusinessRules"
                  @change="specificBusinessRuleChange"
                />
              </template>
              <el-input v-else value="" disabled />
            </el-form-item>
            <el-form-item>
              <div style="display: flex;flex-direction: column;">
                <div style="width: 100%;display: flex;align-items: center;">
                  <el-checkbox v-model="trackingDetailForm.triggerNodeStateRollback" style="flex-grow: 1">{{ $t('SystemMaintenance.TriggerNodeStatesupConfigured') }}</el-checkbox>
                  <i v-if="trackingDetailForm.triggerNodeStateRollback && trackingDetailForm.nodeStatusRollbackList.length < 5" :class="'el-icon-circle-plus' + (readOnly ? ' plus-disabled' : '')" @click="addNodeStatusRollback" />
                </div>
                <template v-if="trackingDetailForm.triggerNodeStateRollback">
                  <div v-for="(item, index) in trackingDetailForm.nodeStatusRollbackList" :key="getKey(trackingDetailForm.nodeStatusRollbackList.length, index)" style="width: 100%;display: flex;align-items: center;">
                    <el-select v-model="item.trackingCode" style="width: 50px;margin-right: 5px;flex-grow: 1" @change="onTrackingCodeChange(item)">
                      <el-option v-for="option in trackingOptionsDict[item.trackingCode]" :key="option.code" :label="$selectByLang(option.chineseName, option.englishName)" :value="option.code" />
                    </el-select>
                    <el-select v-model="item.trackingDetailCode" style="width: 50px;margin-right: 10px;flex-grow: 1">
                      <el-option v-for="option in trackingDetailOptions.filter(p => p.parentCode === item.trackingCode && p.stateType === 1)" :key="option.code" :label="$selectByLang(option.chineseName, option.englishName)" :value="option.code" />
                    </el-select>
                    <i :class="'el-icon-remove' + (readOnly ? ' remove-disabled' : '')" @click="removeNodeStatusRollback(item)" />
                  </div>
                </template>
              </div>
            </el-form-item>
            <el-form-item v-if="isNew || isEdit" :label="$t('CargoMsg.Cargo_ApplicationScope')">
              <el-radio-group v-model="trackingDetailForm.applicationScope">
                <el-radio :label="0" style="margin-top: 7px;">{{ isNew ? $t('SystemMaintenance.AddOnlyCurrentTemplate') : $t('SystemMaintenance.OnlyModifyCurrentTemplate') }}</el-radio>
                <el-radio :label="1" style="margin: 5px 0 7px 0;">{{ isNew ? $t('SystemMaintenance.AddTemplateSameNode') : $t('SystemMaintenance.ModifyTemplateContinNode') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-show="currentTriggerObj.fieldCode==='_itrace_code'" :label="$t('Sop.ExternalEncoding')">
              <cargo-advance-select
                filterable
                :url="url.sys.trackingDetailExternal"
                :headers="['CODE',$t('SeaExport.Name')]"
                :fields="['code','serviceName']"
                :callback-params="{key:'externalCode'}"
                callback-method-type="value"
                :default-value="trackingDetailForm.externalCode"
                :static-options="sopExternalCodeConfigList"
                tag-value="code"
                tag-name="serviceName"
                :filter-tag-names="['code','serviceName']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item v-if="currentTriggerObj.fieldEname==='生成电子文件'" :label="$t('FileHistory.jobType')">
              <cargo-advance-select
                filterable
                :headers="['CODE',$t('SystemMaintenance.ChineseName3')]"
                :fields="['code','name']"
                :callback-params="{key:'documentTypeUuid'}"
                callback-method-type="obj"
                :default-value="trackingDetailForm.documentTypeUuid"
                :static-options="documentTypeList"
                tag-value="uuid"
                tag-name="name"
                :filter-tag-names="['code','name']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WhetherToDisclose')">
              <el-checkbox v-model="trackingDetailForm.published" />
            </el-form-item>
            <el-form-item :label="$t('Sop.ReportTemplate')">
              <cargo-advance-select
                filterable
                :headers="[$t('CargoMsg.Cargo_ChineseName')]"
                :fields="['name']"
                :callback-params="{key:'templateUuid'}"
                callback-method-type="value"
                :default-value="trackingDetailForm.templateUuid"
                :static-options="reportTemplateList"
                tag-value="uuid"
                tag-name="name"
                :filter-tag-names="['name']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="trackingDetailForm.remark"
                type="textarea"
                :rows="3"
              />
            </el-form-item>
            <el-form-item :label="$t('FinanceManage.charge_sp7')">
              <div style="display: flex">
                <el-input
                  v-model="txtCharge"
                  style="width: 80%;padding-right: 10px"
                  :disabled="true"
                />
                <el-button type="primary" @click="selectHandler">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
        <!--状态变更通知-->
        <el-card ref="trackNoteByInside" style="width: 40%;">
          <el-form :disabled="readOnly" style="width:100%;" label-position="left" label-width="0px">
            <span class="title" :title="$t('CargoMsg.Cargo_SendSettings')">{{ $t('CargoMsg.Cargo_SendSettings') }}</span>
            <el-form-item label="">
              <el-radio-group v-model="trackingDetailForm.sendInnerNotify">
                <el-radio :label="true">{{ $t('Sop.SendNotifications') }}</el-radio>
                <el-radio :label="false">{{ $t('Sop.NotSendNotifications') }}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="trackingDetailForm.notifyJobType">
                <el-radio :label="0">{{ $t('CargoMsg.Cargo_NoticeOfEachBill') }}</el-radio>
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_NoNoticeOfTickets') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <span class="title" :title="$t('CargoMsg.Cargo_SetTheNotificationRecipients')">{{ $t('CargoMsg.Cargo_SetTheNotificationRecipients') }}</span>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_DesignatedPost') }}</el-checkbox>
            </el-form-item>
            <el-form-item style="margin-left: 15px" label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.sales" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.Sales') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.op" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.Operation') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.csr" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
            </el-form-item>
            <el-form-item style="margin-left: 15px" label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.overseaOp" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.OverseaCustomerService') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.dc" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.Documents') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.planner" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.AirlinePerson2') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.cargoSales" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.SalesOfGoods') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.siteOp" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId1" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId2" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId3" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole3') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId4" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole4') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId5" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole5') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId6" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole6') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId7" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole7') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId8" :disabled="!trackingDetailForm.innerConfig.post">{{ $t('CargoMsg.Cargo_userDefinedRole8') }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-show="!isPlatform" v-model="trackingDetailForm.innerConfig.personnel" @change="trackingDetailForm.innerConfig.userList=[]">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-show="!isPlatform" label="">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_User"
                :fields="['chineseName']"
                :disabled="!trackingDetailForm.innerConfig.personnel"
                :callback-params="{key:'userList'}"
                callback-method-type="value"
                tag-value="userId"
                tag-name="chineseName"
                :filter-tag-names="['chineseName']"
                :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                :default-multiple-value="trackingDetailForm.innerConfig.userList"
                multiple
                filterable
                style="width:205px;"
                options-width="230px"
                @parentCallBack="getInnerConfigValueFromChild"
              />
            </el-form-item>
            <span class="title" style="margin-top: 20px;width: 100%;">{{ $t('CargoMsg.Cargo_ReminderMethod') }}</span>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.email">{{ $t('CargoMsg.Cargo_Email2') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.weChat">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.bellMsg">{{ $t('Message.Message') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.enterpriseWechat">{{ $t('CargoMsg.Cargo_EnterpriseWechat') }}</el-checkbox>
              <template v-if="currentTriggerObj.multipleTrigger">
                <br>
                <el-checkbox v-model="trackingDetailForm.valueChangePushMsg">{{ $t('SystemMaintenance.TriggerTypeChangePushMsg') }}</el-checkbox>
              </template>
            </el-form-item>
            <span class="title" style="margin-top: 20px;width: 100%;">{{ $t('SystemMaintenance.PushExternalInterfaces') }}</span>
            <el-form-item label="">
              <el-select v-model="trackingDetailForm.externalInterfaceList" collapse-tags multiple clearable style="width:215px;" @clear="handleClear">
                <el-option :label="$t('SystemMaintenance.XhqBillDataUpdate')" value="xhqUpdateBillInfo" />
                <el-option v-show="toExoSystemJYD" :label="$t('SystemMaintenance.msdBillDataUpdate')" value="msdSendJobInfo" />
              </el-select>
              <template v-if="currentTriggerObj.multipleTrigger">
                <br>
                <el-checkbox v-model="trackingDetailForm.valueChangePushInterface">{{ $t('SystemMaintenance.TriggerTypeChangePushInterface') }}</el-checkbox>
              </template>
            </el-form-item>
            <span class="title" style="margin-top: 20px;width: 100%;">{{ $t('SystemMaintenance.TriggerInternalEvent') }}</span>
            <el-form-item label="">
              <!--              <el-select v-model="trackingDetailForm.internalEventCode" clearable style="width:205px;">-->
              <!--                <el-option v-for="item in SHIPPING_MANAGERS" :key="item.code" :label="isZh ? item.chineseName : item.englishName" :value="item.code" />-->
              <!--              </el-select>-->
              <cargo-advance-select
                filterable
                :static-options="SHIPPING_MANAGERS"
                :default-value="trackingDetailForm.internalEventCode"
                tag-name="chineseName"
                tag-value="code"
                style="width:215px;"
                @parentCallBack="p=>trackingDetailForm.internalEventCode=p.value"
              />
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
    <!-- 费用方案导入弹窗 -->
    <tracking-charge-scheme-batch-dialog
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :selected-list="chargePlanDialog.selectList"
      @selectedSchemeHandler="(schemeDetails) => { selectedSchemeHandler(schemeDetails) }"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { Assert } from '@/utils/validate'
import URL from '@/api/urlTranslator'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import TrackingChargeSchemeBatchDialog
  from '@/views/cargo/v0/SeaExport/components/booking/TrackingChargeSchemeBatchDialog'
import TriggerDialog
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/tracking/triggerDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import SpecificBusinessRuleDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/specificBusinessRuleDialog'
import { querySpecificBusinessRuleByTenant } from '@/api/sysManage/baseConfig/instruction'

export default {
  name: 'TrackingDetailForm',
  components: {
    TriggerDialog,
    cargoAdvanceSelect,
    TrackingChargeSchemeBatchDialog,
    SpecificBusinessRuleDialog
  },
  props: {
    trackingDetail: {
      type: Object,
      default: () => {}
    },
    triggerTypes: { // 触发类型
      type: Array,
      default: () => []
    },
    reportTemplateList: { // 报表模板
      type: Array,
      default: () => []
    },
    sopExternalCodeConfigList: { // 外部编码
      type: Array,
      default: () => []
    },
    stateWithNodeCodes: { // 平台模板节点code数据
      type: Object,
      default: () => {}
    },
    docTypeMap: { // 文件类型map
      type: Object,
      default: () => {}
    },
    currentLob: { type: String, default: 'SE' },
    isPlatformCode: { type: Boolean, default: false },
    opStatus: { type: String, default: '' }, // 操作状态：add|edit|read
    trackingOptions: { type: Array, default: () => [] },
    trackingDetailOptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      TRIGGER_WAY_ENUM: {
        FIELD: 0, // 根据字段值触发
        SPECIFIC_BUSINESS_RULE: 1 // 根据特定业务规则触发
      },
      selectTypeNames: TYPE_NAMES,
      stateTypes: [ // 状态类型
        { name: 'STATE_TYPE_NOT_START', value: 1, chineseName: '未开始', englishName: 'NotStart' },
        { name: 'STATE_TYPE_IN', value: 2, chineseName: '进行中', englishName: 'In' },
        { name: 'STATE_TYPE_COMPLETE', value: 3, chineseName: '已完成', englishName: 'Complete' },
        { name: 'STATE_TYPE_EXCPTION', value: 4, chineseName: '异常', englishName: 'Exception' }
      ],
      currentTriggerObj: {}, // 当前触发类型选项
      trackingDetailForm: {
        innerConfig: {
          post: false,
          personnel: false,
          email: false,
          weChat: false,
          bellMsg: false,
          enterpriseWechat: false
        },
        nodeStatusRollbackList: [],
        nodeStatusRollbackDelKeys: []
      },
      chargePlanDialog: {
        visible: false,
        selectList: [],
        isSea: false,
        lob: 'SE'
      },
      triggerTypeList: [],
      triggerTypeConfigMap: {
        columnDefs: [
          {
            headerName: this.$t('sysManage.baseConfig.triggerTypeManagement.entityCode'),
            field: 'entityCode',
            flex: 1
          }, {
            headerName: this.$t('sysManage.baseConfig.triggerTypeManagement.entityName'),
            field: 'entityName',
            flex: 1
          }, {
            headerName: this.$t('sysManage.baseConfig.triggerTypeManagement.entityEname'),
            field: 'entityEname',
            flex: 1
          }, {
            headerName: this.$t('sysManage.baseConfig.triggerTypeManagement.fieldCode'),
            field: 'fieldCode',
            flex: 1
          }, {
            headerName: this.$t('sysManage.baseConfig.triggerTypeManagement.fieldName'),
            field: 'fieldName',
            flex: 1
          }, {
            headerName: this.$t('sysManage.baseConfig.triggerTypeManagement.fieldEname'),
            field: 'fieldEname',
            flex: 1
          }
        ],
        filterKeys: ['entityCode', 'entityName', 'entityEname', 'fieldCode', 'fieldName', 'fieldEname']
      },
      allTriggerTypeList: [],
      txtCharge: '',
      toExoSystemJYD: false,
      SHIPPING_MANAGERS: SystemConstants.CABIN_MANAGERS,
      trackingOptionsDict: {},
      specificBusinessRules: null
    }
  },
  computed: {
    url() {
      return URL
    },
    isNew() {
      return this.opStatus === 'add'
    },
    isEdit() {
      return this.opStatus === 'edit'
    },
    readOnly() {
      return this.opStatus === 'read'
    },
    title() {
      if (this.isNew) {
        return this.$t('CargoMsg.Cargo_NewStatusDetails')
      }
      if (this.isEdit) {
        return this.$t('CargoMsg.Cargo_EditTheStatusDetails')
      }
      return this.$t('CargoMsg.Cargo_StatusDetails')
    },
    fieldEventName() {
      if (this.trackingDetailForm.triggerWay !== this.TRIGGER_WAY_ENUM.FIELD) {
        return ''
      }
      if (!this.allTriggerTypeList || this.allTriggerTypeList.length === 0 || !this.trackingDetailForm.event) {
        return ''
      }
      const data = this.allTriggerTypeList.filter(item => item.uuid === this.trackingDetailForm.event)
      if (data && data.length > 0) {
        return this.isZh ? data[0].fieldName : data[0].fieldEname
      }
      return ''
    },
    specificBusinessRuleEventName() {
      if (this.trackingDetailForm.triggerWay !== this.TRIGGER_WAY_ENUM.SPECIFIC_BUSINESS_RULE) {
        return ''
      }
      if (!this.specificBusinessRules || !this.trackingDetailForm.event) {
        return ''
      }
      const data = this.specificBusinessRules.find(item => item.uuid === this.trackingDetailForm.event)
      return data ? data.ruleName : ''
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    },
    documentTypeList() {
      if (!this.docTypeMap || !this.currentLob) {
        return []
      }
      return this.docTypeMap[this.currentLob]
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    'trackingDetailForm.innerConfig.post': function(val) {
      if (!val && val !== undefined) {
        this.trackingDetailForm.innerConfig.sales = false
        this.trackingDetailForm.innerConfig.overseaOp = false
        this.trackingDetailForm.innerConfig.dc = false
        this.trackingDetailForm.innerConfig.planner = false
        this.trackingDetailForm.innerConfig.op = false
        this.trackingDetailForm.innerConfig.csr = false
        this.trackingDetailForm.innerConfig.siteOp = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId1 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId2 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId3 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId4 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId5 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId6 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId7 = false
        this.trackingDetailForm.innerConfig.userDefinedRoleId8 = false
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.toExoSystemJYD = cache.config.get('ToExoSystem') === 'JYD'
  },
  beforeMount() {
    // 查询特定业务规则
    querySpecificBusinessRuleByTenant({ paging: false }).then(res => {
      this.specificBusinessRules = res.data.list
    })
  },
  methods: {
    onShow() {
      this.loadTriggerTypeList()
      const trackingDetail = this.trackingDetail
      if (trackingDetail.innerConfig && !(trackingDetail.innerConfig instanceof Object)) {
        trackingDetail.innerConfig = JSON.parse(trackingDetail.innerConfig)
        const userList = trackingDetail.innerConfig.userList
        trackingDetail.innerConfig.userList = userList instanceof Array ? userList : (userList ? userList.split(',').map(item => Number(item)) : [])
      }
      if (!trackingDetail.innerConfig) {
        trackingDetail.innerConfig = {
          sales: false,
          overseaOp: false,
          dc: false,
          planner: false,
          op: false,
          csr: false,
          post: false,
          personnel: false,
          cargoSales: false,
          siteOp: false,
          userDefinedRoleId1: false, // 自定义岗位1
          userDefinedRoleId2: false, // 自定义岗位2
          userDefinedRoleId3: false, // 自定义岗位3
          userDefinedRoleId4: false, // 自定义岗位4
          userDefinedRoleId5: false, // 自定义岗位5
          userDefinedRoleId6: false, // 自定义岗位6
          userDefinedRoleId7: false, // 自定义岗位7
          userDefinedRoleId8: false, // 自定义岗位8
          userList: [], // 用户id逗号隔开
          email: false,
          stationNotice: false,
          weChat: false,
          bellMsg: false,
          enterpriseWechat: false
        }
      }
      // 加载触发类型联动
      if (trackingDetail.event) {
        const triggerObj = this.triggerTypeList.find(op => op.uuid === trackingDetail.event)
        this.currentTriggerObj = { ...triggerObj }
      }
      this.trackingDetailForm = trackingDetail
      if (this.trackingDetailForm.nodeStatusRollbackList) {
        for (const item of this.trackingDetailForm.nodeStatusRollbackList) {
          if (this.trackingOptions.findIndex(p => p.code === item.trackingCode) === -1) {
            item.trackingCode = ''
          }
          if (this.trackingDetailOptions.findIndex(p => p.code === item.trackingDetailCode) === -1) {
            item.trackingDetailCode = ''
          }
        }
      }
      this.buildTrackingOptionsDict()
      this.showTxtCharge()
    },
    async checkForm() {
      const { code, stateType, event, type, codeCname, codeEname } = { ...this.trackingDetailForm }
      await Assert.isNotBlank(code, '请输入代码')
      await Assert.isNotBlank(codeCname, this.$t('SystemMaintenance.PleaseEnterChineseName'))
      await Assert.isTrue(codeCname.length < 20, this.$t('SystemMaintenance.ChineseNameLengthExceeds20'))
      await Assert.isNotBlank(codeEname, this.$t('SystemMaintenance.PleaseEnterEnglishName'))
      await Assert.isNotBlank(stateType, this.$t('SystemMaintenance.PleaseSelectStatusType'))
      await Assert.isTrue(!type || event, this.$t('SystemMaintenance.PleaseSelectTriggerType'))
      await Assert.isNotBlank(stateType, this.$t('SystemMaintenance.PleaseSelectStatusType2'))
      await Assert.isTrue(!this.existProperty('code', code), this.$t('SystemMaintenance.ThereSameCodePleaseEnter'))
      await Assert.isTrue(!this.existProperty('codeCname', codeCname), this.$t('SystemMaintenance.ThereSameChineseNameEnter'))
      await Assert.isTrue(!this.existProperty('codeEname', codeEname), this.$t('SystemMaintenance.ThereSameEnglishNameEnter'))
    },
    existProperty(property, value) {
    },
    getValueFromChild(obj) {
      this.trackingDetailForm[obj.key] = obj.value
      if (obj.key === 'event') { // 触发类型
        this.currentTriggerObj = { ...obj }
      }
    },
    changeFieldTrigger(data) {
      if (data) {
        this.trackingDetailForm.event = data.uuid ? data.uuid : ''
        if (data.fieldEname !== '生成电子文件' && this.trackingDetailForm.documentTypeUuid) { // 触发类型变更，由”生成电子文件“变更为其他类型，那么这个字段也要处理一下
          this.trackingDetailForm.documentTypeUuid = ''
        }
        if (!data.multipleTrigger) {
          this.resetMultipleTriggerInfo()
        }
      } else { // 没有选择”触发类型的时候“， 需要把文件类型的也给清空掉
        this.trackingDetailForm.event = ''
        this.trackingDetailForm.documentTypeUuid = ''
        this.resetMultipleTriggerInfo()
      }
      this.currentTriggerObj = data
    },
    resetMultipleTriggerInfo() {
      this.trackingDetailForm.valueChangePushMsg = false
      this.trackingDetailForm.valueChangePushInterface = false
      const configVOList = this.trackingDetail.trackingTemplateConfigVOList
      if (configVOList && configVOList.length > 0) {
        for (const configVO of configVOList) {
          configVO.valueChangePushMsg = false
        }
      }
    },
    loadTriggerTypeList() {
      this.allTriggerTypeList = this.triggerTypes
      this.triggerTypeList = this.triggerTypes.filter(item => item.tenantId === 1)
    },
    getInnerConfigValueFromChild(obj) {
      this.trackingDetailForm.innerConfig[obj.key] = obj.value
    },
    selectHandler() {
      this.chargePlanDialog.selectList = this.trackingDetailForm.chargeSchemeDetailTrackingList
      this.chargePlanDialog.lob = this.currentLob
      this.chargePlanDialog.isSea = this.currentLob === 'SE'
      this.chargePlanDialog.visible = true
    },
    selectedSchemeHandler(data) {
      this.trackingDetailForm.chargeSchemeDetailTrackingList = data
      this.showTxtCharge()
    },
    showTxtCharge() {
      const data = this.trackingDetailForm.chargeSchemeDetailTrackingList
      let txtCharge = ''
      if (data) {
        const texChargeList = data.filter(p => p.chargeItemId === '')
        for (const d of texChargeList) {
          if (!d.parentUuid) {
            if (txtCharge) {
              txtCharge += ';'
            }
            txtCharge += d.name
          }
        }
      }
      this.txtCharge = txtCharge
    },
    typeChange() {
      if (!this.trackingDetailForm.type) { // 取消自动触发的时候，清空“触发类型”
        this.trackingDetailForm.event = ''
        this.trackingDetailForm.documentTypeUuid = ''
        this.resetMultipleTriggerInfo()
        this.currentTriggerObj = {}
      }
    },
    handleClear() {
      this.trackingDetailForm.externalInterfaceList = []
    },
    addNodeStatusRollback() {
      if (this.readOnly) {
        return
      }
      this.trackingDetailForm.nodeStatusRollbackList.push({
        trackingCode: '',
        trackingDetailCode: ''
      })
    },
    removeNodeStatusRollback(item) {
      if (this.readOnly) {
        return
      }
      if (item.uuid) {
        this.trackingDetailForm.nodeStatusRollbackDelKeys.push(item.uuid)
      }
      this.trackingDetailForm.nodeStatusRollbackList = this.trackingDetailForm.nodeStatusRollbackList.filter(p => p !== item)
      this.buildTrackingOptionsDict()
    },
    getKey(total, index) {
      return total * total + index
    },
    buildTrackingOptionsDict() {
      this.trackingOptionsDict = {}
      const usedTrackingCodes = []
      if (this.trackingDetailForm.nodeStatusRollbackList) {
        for (const item of this.trackingDetailForm.nodeStatusRollbackList) {
          if (item.trackingCode) {
            usedTrackingCodes.push(item.trackingCode)
          }
        }
      }
      this.trackingOptionsDict[''] = this.trackingOptions.filter(p => !usedTrackingCodes.includes(p.code))
      for (const option of this.trackingOptions) {
        this.trackingOptionsDict[option.code] = this.trackingOptions.filter(p => !usedTrackingCodes.includes(p.code) || p.code === option.code)
      }
    },
    onTrackingCodeChange(item) {
      item.trackingDetailCode = ''
      this.buildTrackingOptionsDict()
    },
    triggerWayChange() {
      switch (this.trackingDetailForm.triggerWay) {
        case this.TRIGGER_WAY_ENUM.FIELD:
          this.trackingDetailForm.event = ''
          break
        case this.TRIGGER_WAY_ENUM.SPECIFIC_BUSINESS_RULE:
          this.changeFieldTrigger('')
          break
      }
    },
    specificBusinessRuleChange(data) {
      this.trackingDetailForm.event = data ? data.uuid : ''
    }
  }
}
</script>

<style scoped lang="scss">
  .tracking-detail-form{
    .box-card{
      /deep/.el-card__header{
        padding: 10px 20px !important;
      }
    }
    .title{
      display: inline-block;
      position: relative;
      font-size: 13px;
      padding-left: 15px;
      line-height: 14px;
      margin-bottom: 10px;
    }
    .title:before {
      content: '';
      position: absolute;
      width: 4px;
      top: 0;
      left: 0;
      bottom: 0;
      background-color: #1F75D5;
    }
    .el-icon-circle-plus {
      &.plus-disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }
      color: #42b983;
      cursor: pointer;
      font-size: 18px;
    }
    .el-icon-remove {
      &.remove-disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }
      color: #f56c6c;
      cursor: pointer;
      font-size: 18px;
    }
  }
</style>
